import './pages.css';

const AboutUsMission = () => {
    return (
        <div className="page about-us-mission">
            {/* Hero Section */}
            <section className="mission-hero-section">
                <div className="mission-hero-content">
                    <h1>Our Mission</h1>
                    <p className="mission-tagline">Go Digital with AbELab</p>
                    <p className="mission-statement">
                        Empowering clinicians to advance with the dental industry through
                        cutting-edge digital dentistry and exceptional craftsmanship.
                    </p>
                </div>
            </section>

            {/* Main Mission Content */}
            <section className="mission-content-section">
                <div className="content-container">
                    <div className="mission-intro-card">
                        <p>
                            AbELab was founded on the belief that clinicians need to advance along with the dental industry.
                            Our team is dedicated to the integration of digital dentistry into our workflow and the workflows
                            of our clinicians. Every restoration we fabricate utilizes digital advancements to ensure high
                            precision, fit, function, and esthetics.
                        </p>
                    </div>

                    {/* Mission Pillars */}
                    <div className="mission-pillars">
                        <div className="pillar-card">
                            <div className="pillar-icon">🎯</div>
                            <h3>Digital Integration</h3>
                            <p>
                                We embrace the newest innovations, processes, and products to provide clinicians
                                with high-quality restorations that streamline workflows.
                            </p>
                        </div>

                        <div className="pillar-card">
                            <div className="pillar-icon">⚡</div>
                            <h3>Superior Quality</h3>
                            <p>
                                Our expert team utilizes the latest technology to fabricate exceptional products
                                with superior precision, fit, esthetics, and function.
                            </p>
                        </div>

                        <div className="pillar-card">
                            <div className="pillar-icon">💡</div>
                            <h3>Continuous Innovation</h3>
                            <p>
                                We are committed to ongoing research and development, constantly exploring new
                                materials and techniques to stay at the forefront of digital dentistry.
                            </p>
                        </div>
                    </div>

                    {/* Call to Action */}
                    <div className="mission-cta">
                        <h2>Your Digital Dental Partner</h2>
                        <p>
                            AbELab is your digital dental partner that can help bring you into the digital age.
                            Experience the difference of working with a laboratory that prioritizes innovation,
                            quality, and your success.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutUsMission;

